import { render } from "./Meigaranews2recent.vue?vue&type=template&id=71cbe847&scoped=true"
import script from "./Meigaranews2recent.vue?vue&type=script&lang=js"
export * from "./Meigaranews2recent.vue?vue&type=script&lang=js"

import "./Meigaranews2recent.vue?vue&type=style&index=0&id=71cbe847&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cbe847"]])

export default __exports__